export default "__VITE_ASSET__BjHjl_Ba__"